import { inSubGroup, type NavigationEntry, type NavigationSubGroup } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/request.js";
import "@ui5/webcomponents-icons/dist/survey.js";
import "@ui5/webcomponents-icons/dist/sales-quote.js";
import "@ui5/webcomponents-icons/dist/sales-order.js";
import "@ui5/webcomponents-icons/dist/signature.js";
import "@ui5/webcomponents-icons/dist/product.js";
import "@ui5/webcomponents-icons/dist/receipt.js";
import "@ui5/webcomponents-icons/dist/undo.js";
import "@ui5/webcomponents-icons/dist/journey-arrive.js";
import "@ui5/webcomponents-icons/dist/credit-card.js";
import "@ui5/webcomponents-icons/dist/compare.js";
import "@ui5/webcomponents-icons/dist/table-view.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import {
  kindKey,
  kindPermission,
  listPaths,
  purchaseKinds,
  reportKeyName,
  reportKeys,
  reportPermission,
} from "./kinds";
import { purchPermissions } from "./permissions";

const kindSubGroup: Partial<Record<string, NavigationSubGroup>> = {
  contract: "agreements",
  returnRequest: "agreements",
  debitNote: "agreements",
};

const capital = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

const documentIcons: Record<string, string> = {
  requisitions: "request",
  rfqs: "survey",
  quotations: "sales-quote",
  orders: "sales-order",
  contracts: "signature",
  "goods-receipts": "product",
  invoices: "receipt",
  "return-requests": "undo",
  returns: "journey-arrive",
  "debit-notes": "credit-card",
};

/** Purchasing entries of the navigation registry (group `purchasing`, plan module `purchasing`). */
export const purchasingNavigation: readonly NavigationEntry[] = [
  ...purchaseKinds.map((kind) => ({
    key: `purch.${kindKey[kind]}`,
    ...inSubGroup(kindSubGroup[kindKey[kind]]),
    labelKey: `nav.purch${capital(kindKey[kind])}`,
    icon: documentIcons[kind] ?? "receipt",
    path: listPaths[kind],
    permission: kindPermission(kind, "view"),
  })),
  {
    key: "purch.grIr",
    subGroup: "agreements",
    labelKey: "nav.purchGrIr",
    icon: "compare",
    path: "/purch/gr-ir",
    permission: purchPermissions.grIrView,
  },
  {
    key: "purch.returnReasons",
    subGroup: "setup",
    labelKey: "nav.purchReturnReasons",
    icon: "undo",
    path: "/purch/return-reasons",
    permission: purchPermissions.returnReasonView,
  },
  ...reportKeys.map((report) => ({
    key: `purch.report.${reportKeyName[report]}`,
    subGroup: "reports" as const,
    labelKey: `nav.purchReport${capital(reportKeyName[report])}`,
    icon: "table-view",
    path: `/purch/reports/${report}`,
    permission: reportPermission[report],
  })),
  {
    key: "purch.settings",
    subGroup: "setup",
    labelKey: "nav.purchSettings",
    icon: "settings",
    path: "/platform/settings/purch",
    permission: purchPermissions.settingsView,
  },
];
